<template>
  <div class="pay-day-loan-interest-rate">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('list.payDayLoanInterestRate') }}
        </h3>
        <div class="box-tools pull-right">
          <template v-if="can([$Permissions.backend.interestRate.payDay.store])">
            <router-link
              :to="{name: 'InterestRateCreate'}"
              class="btn btn-primary btn-sm"
              data-widget="remove"
            >
              <i class="fa fa-plus-circle" /> {{ $t('interestRate.newInterestRate') }}
            </router-link>
          </template>
        </div>
      </div>
      <div class="box-body">
        <table
          id="interest-rate-table"
          class="table table-hover table-striped table-bordered"
        >
          <thead>
            <tr>
              <th>{{ $t('table.action') }}</th>
              <th>{{ $t('table.createdAt') }}</th>
              <th>{{ $t('table.startAmount') }}</th>
              <th>{{ $t('table.endAmount') }}</th>
              <th>{{ $t('table.startDay') }}</th>
              <th>{{ $t('table.endDay') }}</th>
              <th>{{ $t('table.percentage') }}</th>
            </tr>
          </thead>
          <tbody />
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InterestRate',
  metaInfo () {
    return {
      title: this.$t('string.listInterestRate'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  data () {
    return {
      oTable: null
    }
  },
  watch: {
    '$i18n.locale': function () {
      this.oTable.clear()
      this.oTable.destroy()
      this.oTable = this.dataTable()
      this.oTable.draw(true)
    },
    oTable: function () {
      this.dataTableActions()
    }
  },
  methods: {
    dataTable () {
      const self = this
      return $('#interest-rate-table').DataTable({
        stateSave: true,
        processing: true,
        serverSide: true,
        scrollX: true,
        scrollCollapse: true,
        lengthMenu: this.$lengthMenu,
        ajax: {
          method: 'POST',
          url: process.env.VUE_APP_API + '/api/v1/interest-rate',
          data: (d) => {
            d.labelEdit = self.$t('label.edit')
            d.labelDelete = self.$t('label.delete')
            d.noPermission = self.$t('string.noPermission')
          },
          error: (xhr) => {
            this.onAccessDenied(xhr)
          }
        },
        columns: [
          {
            data: 'action',
            name: 'action',
            searchable: false,
            orderable: false,
            width: '2%',
            title: this.$t('table.action')
          },
          {
            data: 'created_at',
            name: 'created_at',
            searchable: false,
            width: '8%',
            title: this.$t('table.createdAt')
          },
          { data: 'start_amount', name: 'start_amount', width: '8%', title: this.$t('table.startAmount') },
          { data: 'end_amount', name: 'end_amount', width: '8%', title: this.$t('table.endAmount') },
          { data: 'start', name: 'start', width: '8%', title: this.$t('table.startDay') },
          { data: 'end', name: 'end', width: '8%', title: this.$t('table.endDay') },
          { data: 'percentage', name: 'percentage', width: '8%', title: this.$t('table.percentage') }
        ],
        order: [[2, 'asc']],
        language: {
          url: `/locale/${this.$i18n.locale}.json`
        }
      })
    },
    dataTableActions () {
      this.clearEventHandlers([
        '.interest-rate-delete',
        '.interest-rate-edit',
        '.interest-rate-mark-as-inactive',
        '.interest-rate-mark-as-active'
      ])
      const self = this
      $(document).on('click', '.interest-rate-delete', function () {
        self.deleteInterest($(this).attr('data-interest-rate'))
      })
      $(document).on('click', '.interest-rate-mark-as-inactive', function () {
        self.markAsActiveInterestRate($(this).attr('data-interest-rate'), false)
      })
      $(document).on('click', '.interest-rate-mark-as-active', function () {
        self.markAsActiveInterestRate($(this).attr('data-interest-rate'), true)
      })

      $(document).on('click', '.interest-rate-edit', function () {
        const id = $(this).attr('data-interest-rate')
        self.$router.push({
          name: 'InterestRateEdit',
          params: {
            id: id
          }
        })
      })
    },
    refreshDataTable () {
      this.oTable.draw(true)
    },
    deleteInterest (id) {
      const self = this
      this.$swal({
        title: self.$t('string.areYouSure?'),
        text: self.$t('string.youWillNotBeAbleToRevertThis!'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: self.$t('string.yesDeleteIt'),
        cancelButtonText: self.$t('button.cancel')
      }).then((result) => {
        if (result.value) {
          self.$axios.post(process.env.VUE_APP_API + '/api/v1/interest-rate/delete', { id: id })
            .then((response) => {
              self.refreshDataTable()
              self.$swal({
                title: self.$t('string.deleteInterestRateRequest!'),
                text: self.$t('string.theRecordHasBeenDeleted!'),
                type: response.data.code === 1 ? 'success' : 'error',
                confirmButtonText: self.$t('button.ok')
              })
            })
        }
      })
    },
    markAsActiveInterestRate (id, active) {
      const self = this
      this.$swal({
        title: self.$t('string.areYouSure?'),
        text: self.$t('string.youWillNotBeAbleToRevertThis!'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, active it!'
      }).then((result) => {
        if (result.value) {
          self.$axios.post(process.env.VUE_APP_API + '/api/v1/interest-rate/mark-as-active', {
            id: id,
            active: active
          })
            .then((response) => {
              if (response.data.code === 1) {
                self.refreshDataTable()
              }
              self.$swal(
                'Active Interest Rate Request!',
                response.data.message,
                response.data.code === 1 ? 'success' : 'error'
              )
            })
        }
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.oTable = this.dataTable()
      this.dataTableActions()
    })
  },
  beforeDestroy () {
    this.oTable.clear()
    this.oTable.destroy()
  }
}
</script>

<style scoped>

</style>
